import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=a1b82776&scoped=true&"
import script from "./SettingsPage.vue?vue&type=script&lang=js&"
export * from "./SettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=a1b82776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b82776",
  null
  
)

export default component.exports